import styled from "styled-components";
import { margin, type MarginProps } from "styled-system";

export const StyledSVG = styled.svg<MarginProps>`
  ${margin}
`;
